
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/access-investor",
      function () {
        return require("private-next-pages/account/access-investor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/access-investor"])
      });
    }
  